'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCheck, iconCheckTag } from '@ni/nimble-components/dist/esm/icons/check';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCheck };
export { iconCheckTag };
export const NimbleIconCheck = wrap(IconCheck);